import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Dialog,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Colors from "../../../assests/style";
import { useForm } from "react-hook-form";
import { SecondaryButton } from "../../../components/Buttons";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Images } from "../../../assests";
import { useNavigate } from "react-router-dom";
import OrderServices from "../../../services/OrderServices";
import Swal from "sweetalert2";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";
import { Helmet } from "react-helmet";

const Blogs = () => {
  const navigate = useNavigate();
  const [partnerModal, setPartnerModal] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const getBlogs = async () => {
    let params = { page: 1, limit: 999999 };
    setLoading(true);
    try {
      const data = await OrderServices.getBlogs(params);
      setBlogs(data?.data?.blogs || []);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getBlogs();
  }, []);

  const onSubmit = async (formData) => {
    setPartnerModal(false);
    try {
      const obj = {
        name: formData?.name,
        email: formData?.email,
        subject: formData?.subject,
        message: formData?.message,
      };
      await OrderServices.SubmitMail(obj);
      Swal.fire({
        title: "Thanks for reaching out! We’ll reply soon.",
        icon: "success",
        background: "#0f172a",
        color: "#fff",
      });
      reset();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There was an error sending your message. Please try again later.",
      });
    }
  };

  return (
    <div>
      <Helmet>
        <title>Blogs | Print Me Up</title>
        <meta
          name="description"
          content="Explore the latest blogs from Print Me Up — learn about AI printing, design trends, t-shirt customization ideas, and much more!"
        />
        <link rel="canonical" href="https://pk.printmeup.ai/blog" />
      </Helmet>

        <Box
             sx={{
               backgroundImage: `url("${Images.contactBg}")`,
               backgroundSize: "cover",
               backgroundRepeat: "no-repeat",
               backgroundPosition: "center",
               width: "100%",
               height: {lg:"300px",md:'300px',sm:'220px',xs:'220px'}, // Adjust height as needed
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
               position: "relative",
             }}
           >
             {/* <Box
                         sx={{
                             position: "absolute",
                             top: 0,
                             width: "100%",
                             height: "100%",
                             background: Colors.backgroundColor1
                         }}
                     /> */}
             <Box
               sx={{
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 gap: 1.5,
               }}
             >
               <Box
                 component={"p"}
                 className="banner-text heading-font"
                 sx={{
                   fontSize: { lg: "52px", md: "52px", sm: "52px", xs: "30px" },
                   textAlign: "center",
                   fontFamily: "Noto Sans, sans-serif",
                 }}
               >
                 {" "}
                 Blogs{" "}
               </Box>
             
     
               {/* <p style={{ fontSize: '25px', textAlign: 'center', color: 'white', fontFamily: "Noto Sans, sans-serif", }}>Homepage || <span style={{ color: Colors.secondary }}>Contact Us</span></p> */}
             </Box>
           </Box>

      {/* Blog Container */}
      <Box
        component="section"
        sx={{
          py: 8,
          background: "linear-gradient(180deg, #0C1427 0%, #101B35 100%)",
        }}
      >
        <Grid container justifyContent="center">
          <Grid item md={9.5} sm={11} xs={11}>
            <Grid
              container
              spacing={4}
              sx={{
                borderRadius: "20px",
                p: { xs: 2, sm: 3, md: 4 },
                background: Colors.contactGradient1,
              }}
            >
              {loading ? (
  <Typography
    sx={{
      textAlign: "center",
      width: "100%",
      color: "white",
      py: 6,
      fontSize: "18px",
    }}
  >
    Loading blogs...
  </Typography>
) : blogs?.length > 0 ? (
  blogs.map((blog, index) => (
    <Grid
      item
      lg={4}
      md={4}
      sm={6}
      xs={12}
      key={index}
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Card
        sx={{
          width: "100%",
          background: "#0F172A",
          color: "white",
          borderRadius: "16px",
          boxShadow:
            "0 4px 15px rgba(11,193,217,0.15), inset 0 0 10px rgba(11,193,217,0.1)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          "&:hover": {
            transform: "translateY(-10px)",
            boxShadow:
              "0 8px 25px rgba(11,193,217,0.35), inset 0 0 15px rgba(11,193,217,0.2)",
          },
        }}
      >
        <CardActionArea onClick={() => navigate(`/blog/${blog._id}`)}>
          <CardMedia
            component="img"
            height="200"
            image={blog?.image || Images.placeholder}
            alt={blog?.title || "Blog Image"}
            sx={{
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
              objectFit: "cover",
            }}
          />
          <CardContent>
            <Typography
              gutterBottom
              variant="h6"
              component="div"
              sx={{
                color: "#0bc1d9",
                fontWeight: "bold",
                mb: 1,
              
              }}
            >
              {blog?.title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "rgba(255,255,255,0.8)",
                mb: 2,
              
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {blog?.short_description ||
                blog?.description?.slice(0, 120) + "..."}
            </Typography>
            <Button
              endIcon={<ArrowForwardIcon />}
              sx={{
                background: "#0bc1d9",
                color: "#0C1427",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "8px",
                px: 2,
                py: 1,
                "&:hover": {
                  background: "#09a7c0",
                },
              }}
              onClick={() => navigate(`/blog/${blog._id}`)}
            >
              Read More
            </Button>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  ))
) : (
  <Typography
    sx={{
      textAlign: "center",
      width: "100%",
      color: "white",
      py: 6,
      fontSize: "18px",
    }}
  >
    No blogs available yet.
  </Typography>
)}

            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Blogs;
